<template>
  <transition name="slide-fade" @before-enter="beforeEnter" @after-leave="afterLeave">
    <div v-show="visible" class="modal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" aria-label="Close" @click.prevent="close">
              <span aria-hidden="true">&times;</span>
            </button>
            <h6 class="modal-title">{{ title }}</h6>
          </div>
          <div class="modal-body">
            <slot />
          </div>
          <div class="modal-footer">
            <slot name="footer">
              <button class="btn btn-default">Ok</button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    props: {
      title: { type: String, default: '' }
    },
    data() {
      return {
        visible: false,
        body: null,
        overlay: null
      }
    },
    computed: {
      style() {
        return this.visible ? 'display: block' : 'display: none'
      }
    },
    methods: {
      open() {
        this.overlay = document.createElement('div')
        this.overlay.classList.add('modal-backdrop', 'fade')
        this.body = document.querySelector('body')
        this.body.appendChild(this.overlay)
        this.body.addEventListener('click', () => {
          this.close()
        })
        window.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            this.close()
          }
        })
        this.visible = true
      },
      beforeEnter() {
        this.body.classList.add('modal-open')
        window.requestAnimationFrame(() => {
          this.$el.classList.add('show')
          this.overlay.classList.add('in')
        })
      },
      close() {
        window.requestAnimationFrame(() => {
          this.overlay.classList.remove('in')
        })
        this.visible = false
      },
      afterLeave() {
        this.body.classList.remove('modal-open')
        this.$el.classList.remove('show')
        this.body.removeChild(this.overlay)
      }
    }
  }
</script>
